import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "react-phone-input-2/lib/bootstrap.css";

const CustomerSetPassword = ({ setFieldValue, errors, touched, values }) => {

  return (
    <>
      <div>
        <div className="account-created-pop">
          <p>Set your account password</p>
          <Row>
            <Col lg={12} className="mx-auto">
              <Form className="cmn-form-set">

              <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password"
                    placeholder="Type here"
                    name="password"
                    value={values.password}
                    onChange={(e) => setFieldValue("password", e.target.value)}
                    isInvalid={touched.password && errors.password}
                  />

                  {touched.password && errors.password && (
                    <div className="text-danger">{errors.password}</div>
                  )}
                </Form.Group>

               
              <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control type="password"
                    placeholder="Type here"
                    name="confirmPassword"
                    value={values.confirmPassword}
                    onChange={(e) => setFieldValue("confirmPassword", e.target.value)}
                    isInvalid={touched.confirmPassword && errors.confirmPassword}
                  />

                  {touched.confirmPassword && errors.confirmPassword && (
                    <div className="text-danger">{errors.confirmPassword}</div>
                  )}
                </Form.Group>
         
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default CustomerSetPassword;


